import React, { Component } from 'react'
import { Row, Col, Table, Image, Button, Container, Accordion, Card, Form, Tooltip, OverlayTrigger, Modal } from 'react-bootstrap';
import { components } from 'react-select'
import * as Cookies from "es-cookie";
import moment from 'moment';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import Webcam from "react-webcam";



class Camera extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    handleClick = (e) => {
        const screenshot = e;
        this.props.parenthandleinputchange(screenshot);
        this.props.onHide();
    };


    render() {
        console.log("mmmmm",this.props);
        const videoConstraints = {
            width: 300,
            height: 300,
            facingMode: "environment"
        };

        return (
            <Modal {...this.props} className='refer_modal_Result p-3'
                size="md" aria-labelledby="example-modal-sizes-title-lg">
                <Modal.Header closeButton className='p-2'>
                </Modal.Header>
                <Modal.Body className='bg-popup'>
                    <Webcam
                        audio={false}
                        height={400}
                        screenshotFormat="image/jpeg"
                        width={460}
                        videoConstraints={videoConstraints}
                    >
                        {({ getScreenshot }) => (
                            <Button
                                onClick={(e) => { this.handleClick(getScreenshot()) }}
                                style={{ display: "block", margin: "auto" }}
                            >
                                Capture photo
                            </Button>
                        )}
                    </Webcam>
                </Modal.Body>
            </Modal>
        )
    }
}

export default withRouter(compose(

)(Camera));